import { Logo } from "./Primitives";
import { APP_URL } from "./data";

export const Footer = () => (
  <footer data-testid="footer" className="relative border-t border-[var(--line)] pt-20 pb-10 overflow-hidden">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="grid md:grid-cols-[1.5fr_1fr_1fr] gap-10">
        <div>
          <div className="flex items-center gap-3"><Logo className="h-9 w-9" /><span className="font-display text-xl font-bold">Morphogenesis Analytics</span></div>
          <p className="mt-5 max-w-sm text-sm text-[var(--muted)] leading-relaxed">Protein-structure analysis and evidence-review workbench. Research use only — not a clinical diagnostic or drug-response predictor.</p>
          <p className="mt-4 text-sm text-[var(--muted)]">Created by <span className="text-[var(--text)] font-semibold">Michael Varman</span></p>
        </div>
        <div className="grid gap-3 text-sm">
          <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-[var(--muted)]">Explore</p>
          {[["Evidence", "#evidence"], ["Modules", "#modules"], ["Triage", "#triage"], ["Exports", "#exports"]].map(([l, h]) => (
            <a key={h} href={h} data-testid={`footer-link-${l.toLowerCase()}`} className="hover:text-[var(--teal)] transition-colors">{l}</a>
          ))}
        </div>
        <div className="grid gap-3 text-sm content-start">
          <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-[var(--muted)]">Workbench</p>
          <a href={APP_URL} target="_blank" rel="noreferrer" data-testid="footer-app-link" className="hover:text-[var(--teal)] transition-colors">Open the app ↗</a>
          <a href="#founder" data-testid="footer-founder-link" className="hover:text-[var(--teal)] transition-colors">Why it exists</a>
          <a href="#contact" data-testid="footer-waitlist-link" className="hover:text-[var(--teal)] transition-colors">Get in touch</a>
        </div>
      </div>
      <p aria-hidden="true" className="font-display mt-20 text-[12.6vw] lg:text-[11.2rem] font-extrabold tracking-[-0.05em] leading-[0.8] text-outline select-none">Morphogenesis</p>
      <div className="mt-8 flex flex-col sm:flex-row justify-between gap-2 font-mono text-[11px] text-[var(--muted)]">
        <span>© 2026 Morphogenesis Analytics · Created by <span data-testid="footer-creator" className="text-[var(--text)] font-medium">Michael Varman</span></span>
        <span>Cα backbone · Kabsch RMSD · RCSB / PDBe / PDBj</span>
      </div>
    </div>
  </footer>
);
